const whatsAppEmojiPublicBucket = process.env.REACT_APP_WHATS_APP_EMOJI_PUBLIC_BUCKET || "oktto-public"
const whatsAppEmojiPublicRegion = process.env.REACT_APP_WHATS_APP_EMOJI_PUBLIC_REGION || "us-east-1"
const whatsAppEmojiPublicPath = "chat/emojis/whatsapp/30"
const whatsAppEmojiPublicBaseUrl = process.env.REACT_APP_WHATS_APP_EMOJI_PUBLIC_BASE_URL || `https://${whatsAppEmojiPublicBucket}.s3.${whatsAppEmojiPublicRegion}.amazonaws.com/${whatsAppEmojiPublicPath}`

const getWhatsAppEmojiAssetUrlByCode = (code = "") => {
    return code ? `${whatsAppEmojiPublicBaseUrl}/${code}.png` : ""
}

const getWhatsAppEmojiSpriteAssetUrl = (file = "") => {
    return file ? `${whatsAppEmojiPublicBaseUrl}/sprites/${file}` : ""
}

export { whatsAppEmojiPublicPath, getWhatsAppEmojiAssetUrlByCode, getWhatsAppEmojiSpriteAssetUrl }
